import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Typography, Input, Button, Select, Space } from 'antd';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import {
  apiCreateDevice,
  apiGetDeviceById,
  apiUpdateDevice
} from '@services/ManageDevices/DeviceServices';
import { showSuccess } from '@components/notification';
import { SelectCommunity } from '@page/Common/SelectCommunity';
import moment, { now } from 'moment';
import TextArea from 'antd/es/input/TextArea';

const { Title } = Typography;

const validationSchema = Yup.object({
  imei: Yup.string().required('Trường này là bắt buộc'),
  serial_no: Yup.string().required('Trường này là bắt buộc'),
  customer_id: Yup.string().required('Trường này là bắt buộc'),
  imsi: Yup.string().required('Trường này là bắt buộc'),
  iccid: Yup.string().required('Trường này là bắt buộc'),
  model: Yup.string().required('Trường này là bắt buộc')
});

export const Replacement = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [loadingFetch, setLoadingFetch] = useState(false);
  const [device, setDevice] = useState({});
  const [remark, setRemark] = useState('');
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      await apiUpdateDevice(values, id);
      showSuccess({ message: 'Thành công!' });
      navigate('/devices');
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const fetch = async () => {
    try {
      setLoadingFetch(true);
      const res = await apiGetDeviceById(id);
      if (res) {
        setDevice(res?.data?.data);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingFetch(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetch();
    }
  }, [id]);

  return (
    <>
      <Card
        title={'Thông tin thiết bị mới'}
        loading={loadingFetch}
        bodyStyle={{ padding: '24px', paddingTop: '0px' }}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Formik
              enableReinitialize
              initialValues={{
                serial_no: '',
                imei: '',
                imsi: '',
                iccid: '',
                customer_id: device?.customer_id ?? '',
                model: '',
                community: device?.community ?? 'HP',
                old_devices: [
                  ...(device?.old_devices || []),
                  {
                    serial_no: device?.serial_no || '',
                    imei: device?.imei || '',
                    imsi: device?.imsi || '',
                    iccid: device?.iccid || '',
                    customer_id: device?.customer_id || '',
                    model: device?.model || '',
                    community: device?.community || '',
                    meter_reading: device?.meter_reading || '',
                    replace_date: moment().format('YYYY-MM-DD HH:mm:ss'),
                    remark: ''
                  }
                ]
              }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}>
              {({ setFieldValue, values }) => (
                <Form>
                  <Row gutter={[16, 16]}>
                    <Col md={6} xs={12}>
                      <Title level={5}>Mã thiết bị (*)</Title>
                      <Field name="serial_no">
                        {({ field }) => <Input {...field} placeholder="Nhập mã thiết bị" />}
                      </Field>
                      <ErrorMessage name="serial_no" component="div" style={{ color: 'red' }} />
                    </Col>
                    <Col md={6} xs={12}>
                      <Title level={5}>IMEI (*)</Title>
                      <Field name="imei">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập IMEI"
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="imei" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col md={6} xs={12}>
                      <Title level={5}>IMSI (*)</Title>
                      <Field name="imsi">
                        {({ field }) => <Input {...field} placeholder="Nhập imsi" />}
                      </Field>
                      <ErrorMessage name="imsi" component="div" style={{ color: 'red' }} />
                    </Col>
                    <Col md={6} xs={12}>
                      <Title level={5}>ICCID (*)</Title>
                      <Field name="iccid">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập iccid"
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="iccid" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col md={6} xs={12}>
                      <Title level={5}>Model (*)</Title>
                      <Field name="model">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập model"
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="model" component="div" style={{ color: 'red' }} />
                    </Col>
                    <Col md={6} xs={12}>
                      <Title level={5}>Mã khách hàng (*)</Title>
                      <Field name="customer_id">
                        {({ field }) => (
                          <Input
                            {...field}
                            placeholder="Nhập mã khách hàng"
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="customer_id" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col md={6} xs={12}>
                      <Title level={5}>Nhà máy (*)</Title>
                      <Field name="community">
                        {({ field }) => (
                          <SelectCommunity
                            {...field}
                            value={values?.community}
                            onChange={(value) => setFieldValue('community', value)}
                            isAll={false}
                            style={{ height: '36px', width: '100%' }}
                          />
                        )}
                      </Field>
                      <ErrorMessage name="community" component="div" style={{ color: 'red' }} />
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    <Col span={24}>
                      <Title level={5}>Lý do thay thế</Title>
                      <Field name={`old_devices.[${device?.old_devices?.length}].remark`}>
                        {({ field }) => (
                          <TextArea
                            {...field}
                            rows={4}
                            placeholder="Nhập lý do thay thê"
                            onChange={(e) =>
                              setFieldValue(
                                `old_devices.[${device?.old_devices?.length}].remark`,
                                e.target.value
                              )
                            } // Handle with Formik's setFieldValue
                          />
                        )}
                      </Field>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} style={{ marginTop: '32px' }}>
                    <Col>
                      <Space>
                        <Button
                          type="primary"
                          onClick={() => navigate('/devices')}
                          icon={<CloseOutlined />}
                          style={{
                            color: '#000',
                            height: '36px',
                            backgroundColor: '#ffff',
                            borderColor: '#ffff',
                            fontSize: '18px'
                          }}>
                          Huỷ
                        </Button>
                        <Button
                          loading={loading}
                          type="primary"
                          htmlType="submit"
                          icon={<SaveOutlined />}
                          style={{
                            color: '#fff',
                            height: '36px',
                            backgroundColor: '#0051A9',
                            borderColor: '#0051A9',
                            fontSize: '18px'
                          }}>
                          {'Thay thế'}
                        </Button>
                      </Space>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>
      </Card>
    </>
  );
};
